import { RootState } from 'store';

export const selectToast = (state: RootState) => state.toast;
